module.exports = __webpack_public_path__ + "assets/pin-orange.3366d8f6.svg";


//////////////////
// WEBPACK FOOTER
// ../source/assets/svgs/pin-orange.svg
// module id = 1629
// module chunks = 6